import React, { useEffect } from 'react';
import './EmailVerifiedPage.scss';
// import { useAtom } from 'jotai';
// import { AccountInfoAtom } from '../../store/AccountStore';

const EmailVerifiedPage = (): void => {
    // const [accountInfo, setAccountInfo] = useAtom(AccountInfoAtom);

    useEffect(() => {
        // accountInfo.verified = true
        // setAccountInfo(accountInfo)
        // console.log('11');
        localStorage.setItem('email_verified', Math.random().toString());
    }, []);

    // useEffect(() => {
    //     console.log('accountInfoaccountInfo', accountInfo);
    // }, [accountInfo]);
};

export default EmailVerifiedPage;